<template>
<div>
  <b-container class="marginal">
    <b-card
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <b-card-body>
        <h2>
          {{$ml.get('failurepayment')}}
        </h2>
        <p>{{$ml.get('paymentfailurep1')}} <a href="mailto:contact@quanteec.com">contact@quanteec.com</a></p>
        
      </b-card-body>
    </b-card>
  </b-container>
</div>
</template>

<script>

export default {
  name: "PluginPaymentFailure",
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {
    
  }

};
</script>